export default __webpack_public_path__ + "static/media/org-details.f3be9066.svg";